/**
 * GasSearch — fetch wrapper around Shopify's predictive search endpoint,
 * shared between the header search trigger and the predictive-search
 * overlay snippet. Rendering stays local to the overlay's own
 * {% javascript %} block since only one component needs it; this file only
 * owns the network call and the open/close event contract.
 *
 *   search:open — request to open the predictive search overlay.
 */
(function () {
  const SEARCH_OPEN = 'search:open';

  function dispatch(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail }));
  }

  let controller = null;

  async function suggest(query, { limit = 6 } = {}) {
    const term = query.trim();
    if (!term) return { products: [] };

    if (controller) controller.abort();
    controller = new AbortController();

    const params = new URLSearchParams({
      q: term,
      'resources[type]': 'product',
      'resources[limit]': String(limit),
      'resources[options][unavailable_products]': 'last',
      'resources[options][fields]': 'title,product_type,variants.title,vendor',
    });

    const response = await fetch(`/search/suggest.json?${params.toString()}`, {
      signal: controller.signal,
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) return { products: [] };
    const data = await response.json();
    return {
      products: (data.resources && data.resources.results && data.resources.results.products) || [],
    };
  }

  function open() {
    dispatch(SEARCH_OPEN, null);
  }

  window.GasSearch = { SEARCH_OPEN, suggest, open };
})();
